"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ClassicRenderer_1 = require("./ClassicRenderer");
var EventStream_1 = require("../event/EventStream");
var overlay_1 = require("../renderable/overlay");
var block_1 = require("../renderable/block");
var container_1 = require("../renderable/container");
var EventType_1 = require("../event/EventType");
var suggestion_1 = require("../renderable/suggestion");
var Accessibility_1 = require("./Accessibility");
/**
 * The content centric renderer tries to maximize the time a content is visible by updating
 * the content if possible or displaying interrupting actions like intent cascading by overlaying the content.
 */
var ContentCentricRenderer = /** @class */ (function (_super) {
    __extends(ContentCentricRenderer, _super);
    function ContentCentricRenderer(content, suggest) {
        var _this = _super.call(this, content, suggest) || this;
        _this.qualifier = null;
        _this.behaviour = function (r, t) { return _this.defaultBehaviour(r, t); };
        return _this;
    }
    ContentCentricRenderer.prototype.init = function (channelId) {
        var _this = this;
        _super.prototype.init.call(this, channelId);
        EventStream_1.default.addListener(EventType_1.EventType.withChannelId(EventType_1.EventType.PUBLISH, channelId), function (e) {
            if (e[0].type === suggestion_1.Suggestion.TYPE) {
                _this.behaviour = _this.suggestionBehaviour(_this.qualifier || "");
            }
        });
        Accessibility_1.enableAccessibilityFeatures();
    };
    /**
     * @inheritDoc
     */
    ContentCentricRenderer.prototype.renderElement = function (renderable, containerType) {
        return this.behaviour(renderable, containerType);
    };
    ContentCentricRenderer.getQualifier = function (renderable) {
        return (renderable["spec"] !== undefined) ? renderable["spec"].qualifier : null;
    };
    ContentCentricRenderer.prototype.defaultBehaviour = function (renderable, containerType) {
        if (!containerType) {
            this.qualifier = ContentCentricRenderer.getQualifier(renderable) || this.qualifier;
        }
        return _super.prototype.renderElement.call(this, renderable, containerType);
    };
    ContentCentricRenderer.prototype.suggestionBehaviour = function (qualifier) {
        var _this = this;
        return function (renderable, containerType) {
            if (ContentCentricRenderer.getQualifier(renderable) === qualifier) {
                var containers = document.getElementsByClassName("lto-container");
                var containerZ = containers[containers.length - 1];
                if (containerZ.parentElement) {
                    containerZ.parentElement.removeChild(containerZ);
                }
                _this.behaviour = function (r, t) { return _this.defaultBehaviour(r, t); };
                return _super.prototype.renderElement.call(_this, renderable, containerType);
            }
            if (renderable instanceof container_1.Container) {
                return _super.prototype.renderElement.call(_this, new overlay_1.Overlay(renderable), new block_1.Block({ type: "block" }));
            }
            return _super.prototype.renderElement.call(_this, renderable, new block_1.Block({ type: "block" }));
        };
    };
    return ContentCentricRenderer;
}(ClassicRenderer_1.ClassicRenderer));
exports.ContentCentricRenderer = ContentCentricRenderer;
